<template>
  <v-container fluid class="promotion-list mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="6" class="d-flex justify-space-between justify-md-start">
              <v-btn to="/promotion/add" color="success" class="button-shadow mr-2">
                <v-icon class="mr-2">mdi-plus</v-icon>
                Add
              </v-btn>
              <v-btn color="success" class="button-shadow mr-2" @click="isFindPromotion=true">
                <v-icon class="mr-2">mdi-file-search</v-icon>
                Find
              </v-btn>
              <v-btn to="/pricelist/list" color="default" class="button-shadow mr-2">
                <v-icon class="mr-2">mdi-file-multiple</v-icon>
                Pricelist
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="ma-1">
          <v-card-text>
            <v-data-table
              :loading="isReceiving || isDeleting"
              loading-text="Loading... Please wait"
              class="promotions-table"
              show-select
              single-select
              item-key="_id"
              sort-by="promotiondate"
              sort-desc
              :footer-props="footer"
              :headers="headers"
              :items="promotions"

              :items-per-page="itemsPerPage">
              <template v-slot:top>
                <v-dialog
                  v-model="isDeletePromotion"
                  width="500"
                >
                  <v-card>
                    <v-card-title>
                      Delete this Promotion?
                    </v-card-title>
                    <v-card-text>
                      {{ deletepromotion.promotioncode }}
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" outlined @click="isDeletePromotion = false">Cancel</v-btn>
                      <v-btn color="secondary" class="button-shadow" @click="deletePromotion(deletepromotion)">Delete</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
              <template v-slot:item.promotionimage="{ item }">
                    <v-img
                    v-if="item.promotionimage" 
                    v-bind:src="item.promotionimage"
                    contain
                    width="100"
                  ></v-img>
              </template>
              <template v-slot:item.promotionstatus="{ item }">
                <v-chip
                  :color="getStatusColor(item.promotionstatus)" small>
                  {{ item.promotionstatus }}
                </v-chip>
              </template>
              <template v-slot:item.promotiondate="{ item }">
                {{ new Date(item.promotiondate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
              </template>
              <template v-slot:item.promotionstartdate="{ item }">
                <p class="two-line">Start: {{ new Date(item.promotionstartdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}</p>
                <p class="two-line">End: {{ new Date(item.promotionenddate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}</p>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn icon color="primary" @click="editPromotion(item)">
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
                <v-btn icon color="primary" @click="deletePromotionDialog(item)">
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <div>
      <v-dialog
        v-model="isFindPromotion"
        persistent
        max-width="600px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Find Promotion</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="6" md="6">
                  <v-menu
                    ref="menu_startdate"
                    v-model="menu_startdate"
                    :close-on-content-click="false"
                    :return-value.sync="find_query.startdate"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        dense
                        v-model="find_query.startdate"
                        label="Start Date"
                        v-bind="attrs"
                        v-bind:value="find_query.startdate"
                        v-on="on"
                        persistent-hint
                        single-line hint="Please enter start date">
                      </v-text-field>
                    </template>
                    <v-date-picker
                      v-model="find_query.startdate"
                      no-title
                      scrollable
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary"
                         @click="menu_startdate = false"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.menu_startdate.save(find_query.startdate)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-menu
                    ref="menu_enddate"
                    v-model="menu_enddate"
                    :close-on-content-click="false"
                    :return-value.sync="find_query.enddate"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        dense
                        v-model="find_query.enddate"
                        label="End Date"
                        v-bind="attrs"
                        v-bind:value="find_query.enddate"
                        v-on="on"
                        persistent-hint
                        single-line hint="Please enter end date">
                      </v-text-field>
                    </template>
                    <v-date-picker
                      v-model="find_query.enddate"
                      no-title
                      scrollable
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary"
                        @click="menu_enddate = false"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.menu_enddate.save(find_query.enddate)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isFindPromotion = false"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="resetFind"
            >
              Reset
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="findPromotion"
            >
              Find
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { getStatusColor } from '../../../util/tools';

export default {
  name: 'PromotionList',
  data() {
    return {
      isDeletePromotion: false,
      isFindPromotion: false,
      menu_startdate: null,
      menu_enddate: null,
      itemsPerPage: 100,
      deletepromotion: {},
      find_query: {},
      headers: [
        { text: 'Image', value: 'promotionimage'},
        { text: 'Name', value: 'promotionname'},
        { text: 'Type', value: 'promotiontype'},
        { text: 'Date', value: 'promotiondate' },
        { text: 'Period', value: 'promotionstartdate' },
        { text: 'Status', value: 'promotionstatus' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      footer: {'items-per-page-options': [100, 500, 1000, 5000]},
      data_promotions: [],
      getStatusColor: getStatusColor,    
    }
  },
  computed: {
    ...mapState('Promotion', ['promotions', 'isReceiving', 'isDeleting', 'query']),
  },
  methods: {
    ...mapActions('Promotion', [
      "createPromotionRequest",
      "deletePromotionRequest",
      "getPromotionsRequest",
      "findPromotionsRequest",
      "updatePromotionRequest",
    ]),
    editPromotion(item) {
      this.$router.push({ name: 'PromotionEdit', params: item })
    },
    deletePromotion(item) {
      this.deletePromotionRequest({_id: item._id});
      this.isDeletePromotion = false;
    },
    deletePromotionDialog(item) {
      this.isDeletePromotion = true;
      this.deletepromotion = {
        _id: item._id,
        promotioncode: item.promotioncode,
      }
    },
    async findPromotion(){
      this.isFindPromotion = false;
      if(Object.keys(this.find_query).length==0){
        let result = await this.getPromotionsRequest();
        this.data_promotions = Object.assign([], result);
      }
      else{
        console.log(this.find_query)
        let result = await this.findPromotionsRequest(this.find_query);
        this.data_promotions = Object.assign([], result);
      }
    },
        async resetFind(){
      this.find_query = {};

    },
  },
  async created () {
    if(Object.keys(this.query).length==0){
      if(this.promotions.length==0) await this.getPromotionsRequest();
      this.data_promotions = Object.assign([], this.promotions);
    }
    else {
      this.find_query = Object.assign({}, this.query);
      let result = await this.findPromotionsRequest(this.query);
      this.data_promotions = Object.assign([], result);
    }
  },
}
</script>

<style src="./List.scss" lang="scss"></style>
